import { useMemo, useState } from "react";

const useShareButton = ({ url, title }) => {
  const [open, setOpen] = useState(false);

  const productUrl = url || window.location.href;
  const encodedUrl = encodeURIComponent(productUrl);

  const shareLinks = useMemo(() => ({
    whatsapp: `https://api.whatsapp.com/send?text=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    instagram: `https://www.instagram.com/?url=${encodedUrl}`,
  }), [encodedUrl]);

  const handleShare = async () => {
    // Mobile native share
    if (navigator.share) {
      try {
        await navigator.share({
          title: title || document.title,
          text: title ? `Check out ${title}` : "Check this out!",
          url: productUrl,
        });
      } catch (err) {
        console.log("Share cancelled");
      }
    } else {
      // Desktop fallback → open dropdown
      setOpen(true);
    }
  };

  return {
    open,
    setOpen,
    shareLinks,
    handleShare,
  };
};

export default useShareButton;